import { render, staticRenderFns } from "./DieticiansNoteStatus.vue?vue&type=template&id=58881a4e&scoped=true&"
import script from "./DieticiansNoteStatus.vue?vue&type=script&lang=js&"
export * from "./DieticiansNoteStatus.vue?vue&type=script&lang=js&"
import style0 from "./DieticiansNoteStatus.vue?vue&type=style&index=0&id=58881a4e&prod&scoped=true&lang=css&"
import style1 from "./DieticiansNoteStatus.vue?vue&type=style&index=1&id=58881a4e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58881a4e",
  null
  
)

export default component.exports